'use client';
import { App } from '@web/query/App';
function Features() {
  App.useFeatures();

  return null;
}

export { Features };
